export const CREATE_INVENTORY = {
	REQUEST: 'CREATE_INVENTORY.REQUEST',
	SUCCESS: 'CREATE_INVENTORY.SUCCESS',
	FAILED: 'CREATE_INVENTORY.FAILED'
};
